import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import './App.css';
import Home from './pages/Home';
import About from './pages/About';
import CaseStudies from './pages/CaseStudies';
import Careers from './pages/Careers';
import Contact from './pages/Contact';
import Analytics from './components/Analytics';
import ChatWidget from './components/ChatWidget';
import ScrollToTop from './components/ScrollToTop';
import ScrollToTopButton from './components/ScrollToTopButton';

function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <header className="header">
      <div className="header-container">
        <Link to="/" className="logo-container">
          <img 
            src="/vithminds-logo.svg" 
            alt="Vithminds Logo" 
            className="logo" 
          />
        </Link>
        <button 
          className="mobile-menu-btn" 
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          ☰
        </button>
        <nav className={`nav-menu ${mobileMenuOpen ? 'active' : ''}`}>
          <Link to="/" className={`nav-link ${isActive('/') ? 'active' : ''}`}>Home</Link>
          <Link to="/about-us" className={`nav-link ${isActive('/about-us') ? 'active' : ''}`}>About Us</Link>
          <Link to="/case-studies" className={`nav-link ${isActive('/case-studies') ? 'active' : ''}`}>Case Studies</Link>
          <Link to="/careers" className={`nav-link ${isActive('/careers') ? 'active' : ''}`}>Careers</Link>
          <Link to="/contact-us" className={`nav-link ${isActive('/contact-us') ? 'active' : ''}`}>Contact Us</Link>
        </nav>
      </div>
    </header>
  );
}

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid-new">
          <div className="footer-section">
            <div className="footer-logo-section">
              <img 
                src="/vithminds-logo.svg" 
                alt="Vithminds Logo" 
                className="footer-logo" 
              />
              <p className="footer-tagline">Empowering enterprises with AI-first digital transformation solutions that drive measurable results and lasting success.</p>
            </div>
          </div>
          <div className="footer-section">
            <h3>INDIA</h3>
            <p className="footer-company-name">Vithminds Technologies Private Limited</p>
            <p>Flat No 302 C Block<br/>Vazhraa Vihhari Manikonda<br/>Hyderabad, Telangana<br/>India 500089</p>
          </div>
          <div className="footer-section">
            <h3>Quick Links</h3>
            <Link to="/">Home</Link>
            <Link to="/about-us">About Us</Link>
            <Link to="/case-studies">Case Studies</Link>
            <Link to="/careers">Careers</Link>
            <Link to="/contact-us">Contact Us</Link>
            <Link to="/">AI Services</Link>
            <Link to="/">Data Services</Link>
          </div>
          <div className="footer-section">
            <h3>Follow us</h3>
            <div className="footer-social">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">Facebook</a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">Instagram</a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">Twitter</a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">LinkedIn</a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer">YouTube</a>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2025 Vithminds Technologies Private Limited. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Analytics />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about-us" element={<About />} />
          <Route path="/case-studies" element={<CaseStudies />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/contact-us" element={<Contact />} />
        </Routes>
        <Footer />
        <ScrollToTopButton />
        <ChatWidget />
      </div>
    </Router>
  );
}

export default App;